import { prysmDB } from './database';

export const getVisitorUUID = async () => {
  try {
    const uuidData = await prysmDB.get('visitorUUID', 'current_uuid');
    return uuidData ? uuidData.uuid : null;
  } catch (error) {
    console.error('[uuidManager] Error getting visitor UUID:', error);
    return null;
  }
};

export const setVisitorUUID = async (uuid) => {
  try {
    await prysmDB.set('visitorUUID', 'current_uuid', { uuid });
    console.log('[uuidManager] Visitor UUID set successfully:', uuid);
  } catch (error) {
    console.error('[uuidManager] Error setting visitor UUID:', error);
  }
}; 